import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 44c11.047 0 20-8.953 20-20 0-11.046-8.953-20-20-20C12.954 4 4 12.953 4 24s8.953 20 20 20Zm3.69-10.31a1 1 0 0 0 0-1.414l-7.234-7.23a1.5 1.5 0 0 1-.001-2.12l7.217-7.237a1 1 0 1 0-1.417-1.412l-7.216 7.236a3.5 3.5 0 0 0 .004 4.947l7.233 7.23a1 1 0 0 0 1.415 0Z",
    fill: "currentColor"
  }));
};

var SvgCircledLeft = styled(SvgComponent).withConfig({
  displayName: "CircledLeft__SvgCircledLeft",
  componentId: "sc-1sm8szk-0"
})(["", " ", ""], size, color);
export default SvgCircledLeft;